import './bootstrap/index'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueMq from 'vue-mq'
import VueAnnouncer from '@vue-a11y/announcer'
import { sync } from 'vuex-router-sync'
import { SplitFactory } from '@splitsoftware/splitio'

import polyfill from '@/polyfill'
import App from '@/App.vue'
import router from '@/router'
import filters from '@/filters'
import directives from '@/directives'
import store from '@/store'
import { initializeGoogleMaps } from '@/services/googleMapsLoader'
import featureFlagService from './services/featureFlagService'

polyfill().then(renderApp)

function renderApp() {
  sync(store, router)

  // initialize Harness / Split feature flags
  featureFlagService.initializeFeatureFlags(store, SplitFactory)

  // Initialize Google Maps AFTER feature flags are ready so the flag value is known
  initializeGoogleMaps(window, document, process.env, store)

  // Watch for feature flag changes and reinitialize Google Maps if needed
  store.watch(
    (state) => state.featureFlags.allFlags?.isGoogleMapsApiKeyEnabled,
    () => {
      // Clear the cached initialization so it will reinitialize with the new flag value
      if (window.google?.maps?.importLibrary) {
        delete window.google.maps.importLibrary
      }
      initializeGoogleMaps(window, document, process.env, store)
    }
  )

  Vue.config.productionTip = false

  Vue.use(BootstrapVue)
  Vue.use(VueMq, {
    breakpoints: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: Infinity,
    },
  })
  Vue.use(filters)
  Vue.use(directives)
  Vue.use(VueAnnouncer, {}, router)

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
